import { cn } from '../lib/cn';

export interface SpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  className?: string;
  /** Announced to screen readers. Omit inside a container that already has a live region. */
  label?: string;
}

const sizes = {
  sm: 'size-4 border-2',
  md: 'size-6 border-2',
  lg: 'size-8 border-[3px]',
} as const;

/**
 * An indeterminate loading indicator.
 *
 * The rotation is suppressed under `prefers-reduced-motion` by the global rule,
 * which leaves a static ring — still a visible "something is happening", with
 * no spinning.
 */
export function Spinner({ size = 'md', className, label }: SpinnerProps) {
  return (
    <span
      className={cn(
        'inline-block animate-spin rounded-full border-current border-e-transparent',
        sizes[size],
        className,
      )}
      role={label ? 'status' : undefined}
      aria-hidden={label ? undefined : true}
    >
      {label ? <span className="hs-sr-only">{label}</span> : null}
    </span>
  );
}
